// extracted by mini-css-extract-plugin
export default {"city-v2":"CityV2_city-v2__A-Pp8","img-wrap":"CityV2_img-wrap__CLRiF","img":"CityV2_img__dKX8g"};